export const isConectaOnix = (onix: string) => [].includes(onix);
